import {Injectable} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {Observable} from "rxjs";
import {ConfirmDialogComponent} from "./confirm-dialog.component";

@Injectable()
export class ConfirmDialogService {
  showConfirm(title, message): Observable<boolean> {
    return ConfirmDialogComponent.showConfirmationDialogModal(
      this.dialogService,
      {title, message},
    );
  }

  confirm(title, message): Promise<boolean> {
    return ConfirmDialogComponent.showConfirmationDialogModal(this.dialogService, {title, message}).toPromise();
  }

  constructor(
    private dialogService: DialogService,
  ) {
  }
}
